import { render, staticRenderFns } from "./AppDropFile.vue?vue&type=template&id=52631cca&scoped=true&"
import script from "./AppDropFile.vue?vue&type=script&lang=js&"
export * from "./AppDropFile.vue?vue&type=script&lang=js&"
import style0 from "./AppDropFile.vue?vue&type=style&index=0&id=52631cca&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52631cca",
  null
  
)

export default component.exports